import {
    useState,
    forwardRef,
    useImperativeHandle,
    useContext,
} from "react"

import ExpandableComponentContext from "../../Contexts/ExpandableComponentContext"

export default forwardRef(({ data, readOnly, isMandatory = true, title }, ref) => {

    const ExpandableComponentData = useContext(ExpandableComponentContext)

    const isInteracted = ExpandableComponentData ? ExpandableComponentData?.isInteracted : false

    const [email, setEmail] = useState(data || "")
    const [error, setError] = useState(false)

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            const emailRegex = /^\S+@\S+\.\S+$/
            let validity = emailRegex.test(email)
            if (!isMandatory && !email) {
                validity = true
            }

            if (validity) {
                setError(false)
            }
            else {
                if (isInteracted) {
                    setError(true)
                }
            }

            return {
                isValid: validity,
                value: email,
            }
        },
    }))

    return (
        <div>
            <label className="block text-sm font-medium text-gray-700">
                {`${title}${isMandatory ? "*" : ""}` || `Email${isMandatory ? "*" : ""}`}
            </label>
            <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`mt-1 block w-full rounded-md border  shadow-sm mb-2 pr-10 pl-3 py-2 focus:ring-blue-500 focus:border-blue-500 ${error ? "border-red-500" : "border-gray-300"}`}
                placeholder="Email"
                disabled={readOnly}
            />
            {error && (
                <p className="mt-1 text-sm text-red-600">Email is invalid</p>
            )}
        </div>
    )
})
